<template>
  <van-swipe class="my-swipe" :class="{ fromTyre: fromTyre }" :autoplay="3000" lazy-render>
    <van-swipe-item v-for="(item, index) in dblclickImage" :key="index">
      <van-image lazy-load width="100%" height="42vw" fit="cover" @click="link(item, index)" :src="item"> </van-image>
    </van-swipe-item>
  </van-swipe>
</template>

<script>
import { reactive, toRefs } from 'vue'
import { ImagePreview } from 'vant'
export default {
  /**
   * "slideList"轮播图 "dblclickImage",放大图 "zoomWay===click"是否单击放大,noEnlarge不放大
   */
  props: ['slideList', 'dblclickImage', 'zoomWay', 'noEnlarge', 'fromTyre'],
  setup(props, { emit }) {
    let { slideList, dblclickImage, zoomWay, noEnlarge, fromTyre } = toRefs(props)
    const state = reactive({
      slideList,
      dblclickImage,
      zoomWay,
      noEnlarge,
      fromTyre
    })
    let isDbl = 0
    const link = (item, i) => {
      isDbl += 1
      clearTimeout(time)
      //单击
      let time = setTimeout(() => {
        if (isDbl === 1) {
          isDbl = 0
          if (state.zoomWay === 'click') {
            // 单击放大
            ImagePreview({
              images: state.dblclickImage,
              startPosition: i
            })
          } else {
            emit('todetail', i)
          }
        }
      }, 300)
      //双击放大
      if (isDbl === 2 && !noEnlarge) {
        isDbl = 0
        clearTimeout(time)
        if (state.zoomWay !== 'click') {
          ImagePreview({
            images: state.dblclickImage,
            startPosition: i
          })
        }
      }
    }
    return {
      ...toRefs(state),
      link
    }
  }
}
</script>

<style lang="scss" scoped>
.my-swipe {
  img {
    width: 100vw;
    height: 210px;
  }
}
.fromTyre {
  :deep(.van-image) {
    display: flex;
    justify-content: center;
    align-items: center;
    background: #e2ebf1;
    img {
      width: 60vw;
      margin-top: 20px;
    }
  }
}
</style>
